import * as PIXI from "pixi";

import { Mc } from "../piou-animate";
import Game from "./Game";

export default class MTSprite<T = {}> {
  x: number;
  y: number;
  root: Mc<{ obj: MTSprite<T> } & T>; //; onde: Mc }>;

  game: Game;

  constructor(game: Game, mc: PIXI.animate.MovieClip) {
    this.root = mc as Mc<{ obj: MTSprite<T> } & T>;
    this.root.obj = this; // Used by frame scripts

    this.x = 0;
    this.y = 0;
    this.root.x = -100;
    this.root.y = -100;

    this.game = game;
    this.game.addSprite(this);
  }

  update() {
    this.root.x = this.x;
    this.root.y = this.y;
  }

  kill() {
    this.game.killSprite(this);
  }

  updatePos() {
    this.root.x = this.x;
    this.root.y = this.y;
  }

  getDist(o: { x: number; y: number }) {
    const dx = o.x - this.x;
    const dy = o.y - this.y;
    return Math.sqrt(dx * dx + dy * dy);
  }

  getAng(o: { x: number; y: number }) {
    const dx = o.x - this.x;
    const dy = o.y - this.y;
    return Math.atan2(dy, dx);
  }

  // UTILS
  isOut(m: number) {
    return (
      this.x < -m ||
      this.x > this.game.level.lvlWidth + m ||
      this.y < -m ||
      this.y > this.game.level.lvlWidth + m
    );
  }
}
